import { Route } from "react-router-dom";
import { Overview } from "./Overview";
import { Playoffs } from "./Playoffs";
import { RequireCap } from "./RequireCap";
import { Schedule } from "./Schedule";
import { Scores } from "./Scores";
import { Setup } from "./Setup";
import { Teams } from "./Teams";
import { TournamentShell } from "./TournamentShell";

/**
 * One tournament's console as a nested route (console spec §3.1). Defined
 * once and mounted by App.tsx AND by every phase test, so what a test asserts
 * is the route table the app serves — a guard tested on a hand-built <Routes>
 * keeps passing after someone registers a page outside it.
 *
 * Each phase is guarded by the capability its page needs; the rail never
 * links to a page the caller cannot open, so the guard only meets bookmarks.
 * `lib/analytics.ts` lists these same paths, and its test reads this file.
 */
export function tournamentRoutes() {
  return (
    <Route path="t/:tid" element={<TournamentShell />}>
      <Route index element={<Overview />} />
      <Route path="setup" element={<RequireCap cap="editEvent"><Setup /></RequireCap>} />
      <Route path="teams" element={<RequireCap cap="runEvent"><Teams /></RequireCap>} />
      <Route path="schedule" element={<RequireCap cap="schedule"><Schedule /></RequireCap>} />
      <Route path="scores" element={<RequireCap cap="score"><Scores /></RequireCap>} />
      <Route path="playoffs" element={<RequireCap cap="runEvent"><Playoffs /></RequireCap>} />
    </Route>
  );
}
